import { Col, Row } from "react-bootstrap";
import { ILicenceProfile } from "../../api/ILicenceProfile";
import LeapHeaderComponent from "../../leap-components/LeapHeaderComponent";

interface IHeaderProps {
  licenceProfile: ILicenceProfile;
}

const HeaderSubComponent = ({ licenceProfile }: IHeaderProps) => {
  return (
    <div>
      <Row className="mb-1">
        <Col className="col-md-12">
          <h1>
            {licenceProfile.organisation} - {licenceProfile.profileNo}
          </h1>
        </Col>
      </Row>
      <Row>
        <Col className="col-md-12">
          <h5>{licenceProfile.type}</h5>
        </Col>
      </Row>
    </div>
  );
};

const LicenceProfileHeader = ({ licenceProfile }: IHeaderProps) => {
  const headerContent = <HeaderSubComponent licenceProfile={licenceProfile} />;
  return <LeapHeaderComponent headerContent={headerContent} />;
};

export default LicenceProfileHeader;
